<template>
  <a-layout-header :style="{'paddingLeft':!isMobile && layout != 'head'?'210px':''}" :class="[fixHeader && 'ant-header-fixedHeader', layout === 'side' ? (sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed') : null, theme, 'global-header' ]">
    <div :class="['global-header-wide', layout]">
      <!-- 头部logo -->
      <!-- <router-link v-if="isMobile || layout === 'head'" to="/" :class="['logo', isMobile ? null : 'pc', theme]">
        <img width="32" src="static/img/fqLogo.png"  alt=""/>
        <h1 v-if="!isMobile">{{systemName}}</h1>
      </router-link> -->
      <!-- <a-divider v-if="isMobile" type="vertical" /> -->
      <div class="globa-header-inBox">
        <a-icon v-if="layout === 'side' && !isMobile" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/>
        <div class="breadcrumb" v-if="layout === 'side'">
          <a-breadcrumb>
            <a-breadcrumb-item :key="item.path" v-for="(item, index) in this.$route.matched">
              <span v-if="index === 0"><router-link to="/">{{item.name}}</router-link></span>
              <span v-else>{{item.name}}</span>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </div>
      <div v-if="layout === 'head'"  class="global-header-menu">
        <i-menu style="height: 64px; line-height: 64px;" class="system-top-menu" :theme="theme" mode="horizontal" :menuData="menuData" @select="onSelect"/>
      </div>
      <div :class="['global-header-right', theme]">
          <header-avatar class="header-item"/>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import HeaderAvatar from './HeaderAvatar'
import IMenu from '@/components/menu/menu'
import { mapState } from 'vuex'

export default {
  name: 'GlobalHeader',
  components: {IMenu, HeaderAvatar},
	props: ['collapsed', 'menuData'],
  computed: {
    ...mapState({
      isMobile: state => state.setting.isMobile,
      layout: state => state.setting.layout,
      systemName: state => state.setting.systemName,
      sidebarOpened: state => state.setting.sidebar.opened,
      fixHeader: state => state.setting.fixHeader
    }),
    theme () {
      return this.layout === 'side' ? 'light' : this.$store.state.setting.theme
    }
  },
  mounted(){
    console.log(this.isMobile)
  },
  methods: {
    toggleCollapse () {
      this.$emit('toggleCollapse')
    },
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="less" scoped>
	.breadcrumb{
		// float: left;
		// margin-top: 16px;
		span{
			font-size: 15px;
			color: #525975;
			// font-weight: bold;
		}
	}
  .trigger {
  	// float: left;
    font-size: 20px;
    // line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color .3s;
  }
  .header-item{
    padding: 0 19px;
    display: inline-block;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
    i{
      font-size: 16px;
      color: rgba(0,0,0,.65);
    }
  }
  .global-header{
    padding: 0 12px 0 0;
    -webkit-box-shadow: 0 1px 4px rgba(0,21,41,.08);
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    position: relative;
    .globa-header-inBox{
      display: flex;
      align-items: center;
    }
    &.light{
      background: #fff;
    }
    &.dark{
      background: #393e46;
    }
    .global-header-wide{
      display: flex;
      justify-content: space-between;
      height: 100%;
      align-items: center;
      // min-width: 800px;
      &.head{
        padding: 0 24px;
      }
      &.side{
      }
      .logo {
        height: 64px;
        line-height: 58px;
        vertical-align: top;
        display: inline-block;
        padding: 0 12px 0 24px;
        cursor: pointer;
        font-size: 20px;
        &.pc{
          padding: 0 12px 0 0;
        }
        img {
          display: inline-block;
          vertical-align: middle;
        }
        h1{
          display: inline-block;
          font-size: 16px;
        }
        &.dark h1{
          color: #fff;
        }
      }
      .global-header-menu{
        display: inline-block;
        width: 80%;
        // min-width: 800px;
      }
      .global-header-right{
        // float: right;
        &.dark{
          color: #fff;
          i{
            color: #fff;
          }
        }
      }
    }
  }
  .ant-header-fixedHeader {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 15;
    width: 100%;
    transition: width .2s;

    &.ant-header-side-opened {
      width: 100%;
      // padding-left: 210px;
    }

    &.ant-header-side-closed {
      width: 100%;
      padding-left: 80px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalHeader.vue